import { FormNames, IFormDefinition } from '../../models/form/IFormDefinition'
import { incomeBaseInfoFieldsDefinition, incomeInfoFieldValidations } from './IncomeInfoFields'
import { AppLinks } from '../../environment/app-links'
import { additionalIncomeInfoFieldValidations } from './AdditionalIncomeFields'

export const incomeInfoForm: IFormDefinition = {
   name: FormNames.IncomeInfoForm, 
   fields: incomeBaseInfoFieldsDefinition,
   urlPath: AppLinks.incomeInfoForm,
   canStepBackInForm: false,
   formValidationFunctions: { ...incomeInfoFieldValidations, ...additionalIncomeInfoFieldValidations }
}